var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.538,
    height: 17.538,
    viewBox: "0 0 17.538 17.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-download",
    "data-name": "Icon awesome-download",
    d: "M7.4,0h2.74a.82.82,0,0,1,.822.822V6.577h3a.684.684,0,0,1,.483,1.168l-5.21,5.213a.664.664,0,0,1-.935,0L3.086,7.745a.684.684,0,0,1,.483-1.168H6.577V.822A.82.82,0,0,1,7.4,0ZM17.538,12.879v3.836a.82.82,0,0,1-.822.822H.822A.82.82,0,0,1,0,16.716V12.879a.82.82,0,0,1,.822-.822H5.847l1.678,1.678a1.755,1.755,0,0,0,2.487,0l1.678-1.678h5.025A.82.82,0,0,1,17.538,12.879ZM13.29,15.893a.685.685,0,1,0-.685.685A.687.687,0,0,0,13.29,15.893Zm2.192,0a.685.685,0,1,0-.685.685A.687.687,0,0,0,15.482,15.893Z",
    fill: "#1492e6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.152b07b585b8b29c213be9a603e91df3.svg";
export { ForwardRef as ReactComponent };